var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_64_5330",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 15,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 39.7705,
    y: 39.6914,
    width: 24,
    height: 24,
    transform: "rotate(-180 39.7705 39.6914)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_64_5330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.4628 19.1914C34.9679 19.1914 35.3955 19.3664 35.7455 19.7164C36.0955 20.0664 36.2705 20.494 36.2705 20.9992L36.2705 34.3837C36.2705 34.8888 36.0955 35.3164 35.7455 35.6664C35.3955 36.0164 34.9679 36.1914 34.4628 36.1914L27.761 36.1914L27.761 34.6914L34.4628 34.6914C34.5398 34.6914 34.6103 34.6593 34.6743 34.5952C34.7384 34.5312 34.7705 34.4607 34.7705 34.3837L34.7705 20.9992C34.7705 20.9222 34.7384 20.8517 34.6743 20.7877C34.6103 20.7235 34.5398 20.6914 34.4628 20.6914L27.761 20.6914L27.761 19.1914L34.4628 19.1914ZM23.5398 23.4222L24.5783 24.5069L22.1435 26.9414L30.6743 26.9414L30.6743 28.4414L22.1435 28.4414L24.5783 30.8759L23.5398 31.9607L19.2705 27.6914L23.5398 23.4222Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.160814fe17cb289b9d54aff4d1f4bbb2.svg";
export { ForwardRef as ReactComponent };